export { BannerStrip as InlineStripCta } from "./banner-strip"
export type { BannerStripProps as InlineStripCtaProps } from "./banner-strip"
